import React, { useState, useEffect, useRef } from "react";
import logo from "../../../Assets/Images/logo.svg";
import clinicLogo from "../../../Assets/Images/clinic.svg";
import utils from "../../../Utils";
import Select, { components } from "react-select";
import "./Header.css";
import authService from "../../../Services/authService";
import { useNavigate } from "react-router-dom";
import strings from "../../../Utils/strings";
import languageImg from "../../Assets/Images/language.svg";
import UseClickOutside from "./UseClickOutside";
import utilFunctions from "../../../Utils/utilFunctions";
import { useTranslation } from "react-i18next";
import clinicService from "../../../Services/clinicService";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../../Firebase/config";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import notificationIcon from "../../../Assets/Icons/notification-bing.png";
import Profile from "../../../Assets/Icons/Profile.png";
import { t } from "../../../Utils/translate";
import moment from "moment";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { toggleRefreshNoti } from "../../../modules/fetchNoti/fetchNotiSlice";

function Header() {
  const nav = useNavigate();
  const dispatch = useDispatch()
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [clinicResponse, setClinicResponse] = useState({});
  const [docRes, setDocREs] = useState({});
  const [hospitalName, setHospitalName] = useState("");
  const [hospitalAddress, setHospitalAddress] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const language = localStorage.getItem("i18nextLng");
   const [notifications, setNotifications] = useState([]);
    const [showNotification, setShowNotification] = useState(false);
    const [loading, setLoading]=useState(false);
     const [hasMore, setHasMore] = useState(true);
     const [page, setPage]=useState(1);
     const [notificationCount, setNotificationCount]=useState(0)
     const limit=10;
       const modalRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    Notification.requestPermission().then((permission) => {
              if (permission === "granted") {
                console.log("Notification permission granted.");
              } else {
                console.warn("Notification permission denied.");
              }})
               .catch((error) => {
              console.error("Error requesting notification permission:", error);
            });
    onMessage(messaging, (payload) => {
      dispatch(toggleRefreshNoti())
      handleNotificationClick(1)
      const notificationTitle = payload.notification.title;
      const notificationOptions = {
        body: payload.notification.body,
      };
      new Notification(notificationTitle, notificationOptions).onclick = function () {
        if (document.visibilityState === "hidden") {
          window.focus();
        }
      };
    });
  }, []);

    useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    let isDoctor = authService.getIsDoctorLogin();
    setIsDoctorLogin(isDoctor);
    getClinicProfile();
    if (authService.getIsDoctorLogin() === "true") {
      getDoctorDetials();
    }
  }, []);

  useEffect(() => {
    setHospitalName(authService.getHospitalName() || clinicResponse?.hospital?.name);
    if (language === "vietnam") {
      setHospitalAddress(clinicResponse?.hospital?.address?.vi || authService.getHospitalAddress());
    } else {
      setHospitalAddress(clinicResponse?.hospital?.address?.en || authService.getHospitalAddress());
    }
  }, [clinicResponse]);

  useEffect(() => {
    if (language === "vietnam") {
      setDoctorName(authService.getDoctorNameVi() || docRes.name?.vi);
    } else {
      setDoctorName(authService.getDoctorNameEn() || docRes.name?.en);
    }
    // console.log(authService.getDoctorName());
  }, [docRes]);

  const postFcmToken = async (fcmToken) => {
    function generateUniqueId() {
      return `${Date.now()}-${Math.floor(Math.random() * 100000000000)}`;
    }
    const uniqueId = generateUniqueId();
    const LocalFcmId = localStorage.getItem(strings.localStorage.deviceId);

    const body = {
      type: "WEB",
      name: LocalFcmId || uniqueId,
      id: LocalFcmId || uniqueId,
      token: fcmToken,
    };

    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.doctorFcmToken(body);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalFcmToken(body);
      }
      if (response.status === "success") {
        localStorage.setItem(strings.localStorage.fcmToken, response.data.token.device.token);
        localStorage.setItem(strings.localStorage.deviceId, response.data.token.device.id);
      }
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const currentLanguage = i18n.language;
    const initialLanguage = utils.constants.languageOptions.find((option) => option.value === currentLanguage);
    setSelectedLanguage(initialLanguage);
  }, [i18n.language]);

  useEffect(() => {
    const requestNotificationPermission = async () => {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        try {
          const fcmToken = await getToken(messaging, {
            vapidKey: "BOhzQmz2wSvJTWYQ1BW8lWGB68bTYKnP0nFTkLZVjETbw3vf-oMbG9yVuazd9rfhzKUrkn2iKFvNM-sjZxM1Vps",
          });

          if (fcmToken) {
            const localFcmToken = localStorage.getItem(strings.localStorage.fcmToken);
            if (fcmToken && fcmToken !== localFcmToken) {
              postFcmToken(fcmToken);
            }
          }
        } catch (error) {
          console.error("Error getting FCM token:", error);
        }
      } else {
        console.error("Permission not granted for notifications.");
      }
    };

    requestNotificationPermission();

    setInterval(
      () => {
        requestNotificationPermission();
      },
      5 * 60 * 1000,
    );
  }, []);

  const handleMenuOpen = () => {
    setIsOpen(true);
    setShowNotification(false)
  };

  const handleMenuClose = () => {
    setIsOpen(false);
  };

  const divRef = useRef(null);
  UseClickOutside(divRef, handleMenuClose);

  const handleViewProfile = () => {
    if (isDoctorLogin === "false") {
      nav(strings.navigation.viewClinicProfile);
    } else {
      nav(strings.navigation.doctorProfileView);
    }
  };

  const changeLanguage = (lng) => {
    console.log("err", lng);

    utilFunctions.changeLanguage(i18n, lng);

    setSelectedLanguage(utils.constants.languageOptions.find((option) => option.value === lng));
  };

  const getClinicProfile = async () => {
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetClinicProfile();
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalProfile();
      }
      if (response.status === "success") {
        setClinicResponse(response.data);
        authService.setClinicName(response.data.hospital.name);
        if (language === "vietnam") {
          authService.setHospitalAddress(response.data.hospital.address?.vi);
        } else {
          authService.setHospitalAddress(response.data.hospital.address?.en);
        }

        authService.setClinicId(response.data.hospital._id);
        authService.setPhoneNumber(response.data.hospital.phoneNumber);
        authService.setCountryCode(response.data.hospital.countryCode);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleLanguageChange = (option) => {
    setSelectedLanguage(option);
    i18n.changeLanguage(option.value);
    window.location.reload();
  };

  useEffect(()=>{
    if(selectedLanguage){
       changeLangTranslation(selectedLanguage.value)
    }
    },[selectedLanguage])

  const getDoctorDetials = async () => {
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.getDoctorDetials();
        console.log("getting header doc profile", response);
      }
      if (response.status === "success") {
        setDocREs(response.data.doctor);
        authService.setDoctorName(response.data.doctor.name.en);
        authService.setDoctorNameEn(response.data.doctor.name.en);
        authService.setDoctorNameVi(response.data.doctor.name.vi);
      }
    } catch (error) {
      console.error(error);
    }
  };

   const changeLangTranslation = async (option) => {
    try {
      let response;
      const language=option === "vietnam" ? "VI":"EN";
      if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalLangTranslation(language);
      }else{
        response = await clinicService.doctorLangTranslation(language);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <div>{props.children}</div>
      </components.SingleValue>
    );
  };
useEffect(()=>{
  handleNotificationClick(1)
},[])
const handleNotificationClick = async (currentPage) => {
  setLoading(true); // Start loading
  try {
    let response;
    if (authService.getIsDoctorLogin() === "false") {
      response = await clinicService.getNotificationsList(limit, currentPage);
    }else{
       response = await clinicService.getDoctorNotificationsList(limit, currentPage);
    } 
        if (response?.status === "success") {
        const newNotifications = response.data.notifications || [];
        // Append new data if page > 1, otherwise replace
        setNotificationCount(response.data.totalUnreadDocument);
        setNotifications((prev) => currentPage === 1 ? newNotifications : [...prev, ...newNotifications]);
      } 
       
      if(response.data.currentPage >= response.data.totalPages){
        setHasMore(false)
      }
      
  } catch (error) {
    console.error('Error fetching notifications:', error);
  } finally {
    setLoading(false); 
  }
};

const handleReadNotification = async (id) => {
    try {
    let response;
    if (authService.getIsDoctorLogin() === "true") {
      response = await clinicService.getDoctorReadNotification(id);
    }else{
       response = await clinicService.getHospitalReadNotification(id);
    } 
      if (response?.status === "success") {
        handleNotificationClick(page);
        setShowNotification(false)
      }   
  } catch (error) {
    console.error('Error Read notifications:', error);
  } 
}

const getNotificationStatus=async(id, data)=>{
     const date= moment(data.startTime).format("YYYY-MM-DD");
     const time = moment(data.startTime).format("hh:mm A");
    try {
    let response;
       if (authService.getIsDoctorLogin() === "false") {
       response = await clinicService.hospitalNotificationStatus(id);
       }else{
        response = await clinicService.DoctorNotificationStatus(id);
       }
     
    const message = response?.data?.message?.toLowerCase() || "";
    if (message.includes("relative not found") || message.includes("không tìm")) {
      toast.error(t("notExistAc"));
      nav("/dashboard");
      return; // ✅ exit early so the next block doesn't run
    }
   const isDoctor = authService.getIsDoctorLogin() === "true";
const status = response.status;

const stateData = {
  doctorId: data.docRedirectionId,
  appointmentId: data.data.id,
  startTime: time,
  appointmentDate: date,
};

if (
  status &&
  !isDoctor &&
  (status === "WAITING_FOR_CLINIC_CONFIRMATION" || status === "CANCELLED" || status === "REJECTED")
) {
  nav("/appointment-request", {
    state: { ...stateData, type: status },
  });
} else if (isDoctor && status === "CANCELLED") {
  toast.error(t("appCancel"));
} else {
  nav("/appointment-aprove", { state: stateData });
}
  } catch (error) {
    console.error('Error fetching notifications status:', error);
  } 
}
  const groupNotificationsByDate = (notificationsArray) => {
  return notificationsArray.reduce((acc, notification) => {
    const dateKey = moment(notification.sentAt).format("YYYY-MM-DD");
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(notification);
    return acc;
  }, {});
};

  const handleLoadMore = () => {
     const nextPage = page + 1;
     setLoading(true);
    setPage(nextPage);
    handleNotificationClick(nextPage)
  };

  const handleNotification =(data)=>{
     handleReadNotification(data._id) 
     getNotificationStatus(data.appointmentId, data)
    
  }

  return (
    <>
      <header
        className="fixed w-[100%] h-[65px] z-[1]"
        style={{ background: "white" }}
      >
        <div className="absolute w-[20%] left-[6rem] mt-6 md:left-22 md:mt-3 [@media(max-width:400px)]:left-[4.5rem]">
          <img src={logo} alt="logo_img" className="h-[30px] max-w-[125px] md:max-w-none" />
        </div>
        <div className="absolute right-10 mt-[10px] md:mt-0 width: auto; language-hospital-resp">
          <div className="flex items-center header-icon-resp">
                <div className="header-notification" ref={modalRef}>
               <div className="notifcation" onClick={()=> setShowNotification(!showNotification) }>
            <div className="noti-counter">{notificationCount > 99 ? "99+" : notificationCount} </div>
             <img src={notificationIcon} alt="clinicLogo" className="h-[1.8rem] mr-6 clinic-logo-resp cursor-pointer" />
            </div>
           {showNotification && (
        <div className="notification-box">
          <div className="noti-head">{t("notifications")}</div>
          <div className="noti-scroll">
            <div className="noti-container">
             {Object.entries(groupNotificationsByDate(notifications)).map(([dateKey, items]) => (
  <div key={dateKey}>
    <div
      className="noti-heading"
      style={{
        width: "max-content",
        fontSize: "14px",
        color: "#787878",
        borderRadius: "5px",
        display: "flex",
        padding: "5px",
        justifyItems: "center",
      }}
    >
       {moment(dateKey).isSame(moment(), 'day')
    ? t('today')
    : moment(dateKey).isSame(moment().subtract(1, 'days'), 'day')
    ? t('yesterday')
    : moment(dateKey).format('MMMM D, YYYY')}
    </div>

    {items
      .sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt))
      .map((notification) => (
        <div key={notification._id} className="notification-item"  onClick={()=>handleNotification(notification)}>
          {/* <div className="notif-profile">
            <img src={Profile} alt="profile" className="profile-pic-noti" />
          </div> */}
          <div className="noti-details">
            <div className={`noti-heading ${notification.isRead ? "noti-read" : "unread-head"}`}>
              {notification.title}
            </div>
            <div className="noti-body">
              {/* {notification.body.length > 80 ? `${notification.body.slice(0, 80)}...` : notification.body} */}
              {notification.body}
            </div>
          </div>
          <div className="noti-time">
            <div>{moment(notification.sentAt).format("HH:mm")}</div>
            <div className={`${notification.isRead ? "" : "noti-unread"}`}></div>
          </div>
        </div>
      ))}
  </div>
))}

            </div>
            {hasMore &&
                  (loading ? (
                    <div className="load-more-container">
                      <div className="load-more-btn-notify">{t("loading")}</div>
                    </div>
                  ) : (
                    <div
                      className="load-more-container"
                      onClick={() => {
                        handleLoadMore();
                      }}
                    >
                      <div className="load-more-btn-notify cursor-pointer">{t("loadMore")}</div>
                    </div>
                  ))}
              </div>
            </div>
      )}
      </div>
      
            <img src={clinicLogo} alt="clinicLogo" className="h-[2rem] mr-2 clinic-logo-resp" />
            {isDesktop && (
              <div className="mt-2">
                <div className="text-l mt-2 profile-clinic-name" onClick={handleViewProfile}>
                  {isDoctorLogin === "false" ? hospitalName : doctorName}
                </div>
                <p className="text-gray-500 text-sm">{isDoctorLogin === "false" ? (hospitalAddress?.length > 20 ? `${hospitalAddress.slice(0, 20)}...` : hospitalAddress) : hospitalName}</p>
              </div>
            )}

            <div className="d-flex">
              <img src={languageImg} className="language-img" alt="Language" />
              <div ref={divRef}>
                {/* <Select
                  className="select-language"
                  isSearchable={false}
                  options={utils.constants.languageOptions}
                  styles={utils.appStyles.languageDropDown}
                  // onChange={(option) => changeLanguage(option.value)}
                  onChange={(option) => {
                    changeLanguage(option.value);
                    window.location.reload();
                  }}
                  value={selectedLanguage}
                  getOptionLabel={(option) => (
                    <div>
                      <div>{option.label}</div>
                      <div>{option.subTitle}</div>
                    </div>
                  )}
                  components={{ SingleValue }}
                  menuPortalTarget={document.body}
                  menuIsOpen={isOpen}
                  onMenuOpen={handleMenuOpen}
                  onMenuClose={handleMenuClose}
                /> */}
                {/* <div>{utils.constants.languageOptions.map(item=>{
                  return <span>{item.label}</span>
                }

                )}</div> */}
                <Select
                  className="select-language"
                  isSearchable={false}
                  options={utils.constants.languageOptions}
                  styles={utils.appStyles.languageDropDown}
                  // onChange={(option) => changeLanguage(option.value)}
                  onChange={handleLanguageChange}
                  value={selectedLanguage}
                  getOptionLabel={(option) => (
                    <div>
                      <div>{option.label}</div>
                      <div>{option.subTitle}</div>
                    </div>
                  )}
                  components={{ SingleValue }}
                  menuPortalTarget={document.body}
                  menuIsOpen={isOpen}
                  onMenuOpen={handleMenuOpen}
                  onMenuClose={handleMenuClose}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
